import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
import { Spinner } from '@/components/ui/Spinner';
import { EmptyState, NoDataIcon } from '@/components/ui/EmptyState';
import { useJournalFeed } from '@/hooks/queries/useJournal';
import { JournalEntryCard } from './JournalEntryCard';

export function JournalFeed({
  symbol,
  chainId,
  title = 'Journal',
}: {
  symbol?: string;
  chainId?: string;
  title?: string;
}) {
  const { data, isLoading, hasNextPage, fetchNextPage, isFetchingNextPage } = useJournalFeed({ symbol, chainId });
  const entries = data?.pages.flatMap((p) => p.entries) ?? [];

  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="py-8 flex justify-center">
            <Spinner />
          </div>
        ) : entries.length === 0 ? (
          <EmptyState
            icon={<NoDataIcon />}
            title="No journal entries yet"
            description="Entries appear as trades open, roll, expire, and close"
          />
        ) : (
          <>
            {entries.map((e) => (
              <JournalEntryCard key={e.id} entry={e} />
            ))}
            {hasNextPage && (
              <div className="pt-3 text-center">
                <Button variant="secondary" onClick={() => fetchNextPage()} disabled={isFetchingNextPage}>
                  {isFetchingNextPage ? 'Loading…' : 'Load more'}
                </Button>
              </div>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
}
